export const assets = {
  logo: 'https://media-manager-c.questera.ai/greta-media/29d79c4109d1c19c2e75790b8e50872c9a33c9d5ce79f6f43f60effe48b91ada6d4fe9244bdd866a6b5eb503d1d2a9a7/images/aW1hZ2UvcG5n/11fa126eab839693d9eaaa20d5eb6fa3.png',
  darkLogo: 'https://media-manager-c.questera.ai/greta-media/29d79c4109d1c19c2e75790b8e50872c9a33c9d5ce79f6f43f60effe48b91ada6d4fe9244bdd866a6b5eb503d1d2a9a7/images/aW1hZ2UvcG5n/11fa126eab839693d9eaaa20d5eb6fa3.png',
  hero: 'https://cloud.sharemyimage.com/2026/08/20/Hero-Botanical-Explosion.png',
  hibiscusCluster: 'https://cloud.sharemyimage.com/2026/08/20/Hibiscus-Luxury-Cluster.png',
  lotusBloom: 'https://cloud.sharemyimage.com/2026/08/20/Blue-Lotus-Royal-Bloom.png',
  peaWave: 'https://cloud.sharemyimage.com/2026/08/20/Butterfly-Pea-Indigo-Wave.png',
  roseSwirl: 'https://cloud.sharemyimage.com/2026/08/20/Rose-Petal-Romantic-Swirl.png',
  ingredientCircle: 'https://cloud.sharemyimage.com/2026/08/20/Botanical-Ingredient-Circle.png',
  floating: 'https://cloud.sharemyimage.com/2026/08/20/Floating-Botanical-Elements-Pack.png',
  corner: 'https://cloud.sharemyimage.com/2026/08/20/Botanical-Corner-Frame.png',
  wellness: 'https://cloud.sharemyimage.com/2026/08/20/Luxury-Herbal-Tea-Lifestyle-Banner.png',
  signature: 'https://cloud.sharemyimage.com/2026/08/20/Signature-Collection-Banner.png'
};

export const productDescriptions = {
  hibiscus: 'Our premium hibiscus flowers are hand-picked from the lush gardens of Sri Lanka and naturally sun-dried to preserve their vibrant crimson colour and rich, tangy flavour. Perfect for herbal teas, culinary creations, and natural wellness preparations. Each batch is carefully sorted to ensure only the finest petals reach you.',
  blueLotus: 'The sacred Blue Lotus has been revered for centuries in Sri Lankan tradition for its calming properties and exquisite beauty. Our blue lotus flowers are gently dried using traditional methods that maintain their delicate blue-purple hue and subtle aromatic profile. Ideal for meditation teas, bath rituals, and premium botanical blends.',
  butterflyPea: 'These stunning butterfly pea flowers produce a mesmerizing indigo-blue infusion that naturally changes colour with pH. Rich in antioxidants and traditionally used in Ayurvedic wellness, our butterfly pea flowers are carefully dried to preserve their vivid colour and mild, earthy flavour.',
  rosePetals: 'Our fragrant rose petals are sourced from premium Sri Lankan rose gardens and delicately dried to retain their romantic aroma and soft blush colour. Perfect for herbal teas, bath soaks, culinary garnishes, and aromatic potpourri. Each petal is hand-selected for quality and freshness.'
};

export const baseProducts = [
  {
    id: 1,
    image: 'https://cloud.sharemyimage.com/2026/08/20/Hibiscus-Flowers.png',
    name: 'Premium Hibiscus Flowers',
    category: 'Herbal Flowers',
    price: 1250,
    weight: '100g',
    description: productDescriptions.hibiscus
  },
  {
    id: 2,
    image: 'https://cloud.sharemyimage.com/2026/08/20/Dry-Blue-Lotus.png',
    name: 'Dry Blue Lotus',
    category: 'Botanical Wellness',
    price: 1850,
    weight: '50g',
    description: productDescriptions.blueLotus
  },
  {
    id: 3,
    image: 'https://cloud.sharemyimage.com/2026/08/20/Butterfly-Pea-Flowers.png',
    name: 'Butterfly Pea Flowers',
    category: 'Herbal Tea',
    price: 980,
    weight: '100g',
    description: productDescriptions.butterflyPea
  },
  {
    id: 4,
    image: 'https://cloud.sharemyimage.com/2026/08/20/Rose-Petals.png',
    name: 'Rose Petals',
    category: 'Floral Botanicals',
    price: 890,
    weight: '100g',
    description: productDescriptions.rosePetals
  }
];

const descriptions = [
  productDescriptions.hibiscus,
  productDescriptions.blueLotus,
  productDescriptions.butterflyPea,
  productDescriptions.rosePetals
];

const variations = ['Classic', 'Select', 'Organic', 'Reserve', 'Signature', 'Pure'];

export const allProducts = Array.from({ length: 75 }, (_, index) => {
  const source = baseProducts[index % baseProducts.length];
  const cycle = Math.floor(index / baseProducts.length);
  return {
    ...source,
    id: index + 1,
    name: cycle ? `${source.name} ${variations[cycle % variations.length]}` : source.name,
    price: source.price + cycle * 35,
    available: index % 11 !== 0,
    description: descriptions[index % descriptions.length]
  };
});

export const categories = [
  {
    title: 'Hibiscus Flowers',
    description: 'Naturally vibrant antioxidant herbal flower.',
    image: assets.hibiscusCluster
  },
  {
    title: 'Dry Blue Lotus',
    description: 'Premium botanical wellness flower.',
    image: assets.lotusBloom
  },
  {
    title: 'Butterfly Pea Flowers',
    description: 'Beautiful naturally blue herbal tea.',
    image: assets.peaWave
  },
  {
    title: 'Rose Petals',
    description: 'Elegant floral wellness ingredient.',
    image: assets.roseSwirl
  }
];

export const bankDetails = {
  bankName: 'Commercial Bank of Ceylon',
  accountName: 'Darshana Global Enterprises (PVT) LTD',
  accountNumber: '8012345678',
  branch: 'Colombo 03'
};